import { Component, Input, OnInit } from '@angular/core';

export interface Card {
  title: string;
  subtitle?: string;
  content?: string;
  class? : string;
  actions?: CardAction[];
}

export interface CardAction {
  route: string;
  label: string;
  routeIcon?: string;
  class?: string;
}
@Component({
  selector: 'app-cards',
  templateUrl: './cards.component.html',
  styleUrls: ['./cards.component.css'],
})
export class CardsComponent implements OnInit {
  @Input() public cards: Card[] = [];
  constructor() {}

  ngOnInit(): void {}
}
